import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {HOTB} from "../../HOTB";
import {HOTBData, IReplayNextPlayerInteraction} from "../../server/HOTBData";

export class PickAndClickPresentation implements FlowStatePresentation {
    private _controller: FlowStateController;

    constructor() {
    }

    start(flowStateController: FlowStateController): void {
        this._controller = flowStateController;
        if (this._controller.state === FlowState.IDLE) {
            if (HOTB.autoPlayPlugin.turnOffAutoplayOnBonus) {
                HOTB.autoPlayPlugin.turnOffAutoplayOnBonus();
            }

            const hotbData: HOTBData = HOTB.model.data,
                tl: gsap.core.Timeline = HOTB.pickAndClickView.showView((index: number) => {
                    this.pickDone(index);
                }, HOTB.apiPlugin.isReplay),
                nextPlayerInteraction: IReplayNextPlayerInteraction | undefined = hotbData.nextPlayerInteraction;

            if (nextPlayerInteraction) {
                if (HOTB.apiPlugin.isReplay && nextPlayerInteraction.selectedIndex) {
                    tl.add((): void => {
                        HOTB.pickAndClickView.onButtonPressed();
                    });
                    tl.to(this, {
                        duration: 0.8
                    });

                    tl.add((): void => {
                        this.pickDone(nextPlayerInteraction.selectedIndex);
                    });
                }
            }
        } else if (this._controller.state === FlowState.RESULT) {
            const tl: gsap.core.Timeline = gsap.timeline();
            tl.add(HOTB.pickAndClickView.hideView());
            tl.add((): void => {
                this._controller.finish();
            });
        }
    }

    private pickDone(index: number): void {
        this._controller.finish();
        HOTB.apiPlugin.betHandler.pickAndClickBet(index, false);
    }
}